module.exports = __webpack_public_path__ + "assets/arrow-right.54eff2c0.svg";